// Globally register base components
import Vue from 'vue';

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
    // Look for files in the current directory
    '.',
    // Look for files in subdirectories
    true,
    // Only include .vue files
    /[a-z]\w+\.vue$/
);

// For each matching file name...
requireComponent.keys().forEach(fileName => {
    // Get the component config
    // Because we export default in our components,
    // we grab the default property
    const componentConfig = requireComponent(fileName).default;

    // Globally register the component
    Vue.component(componentConfig.name, componentConfig);
});
